export default "__VITE_ASSET__B3pDWOj3__"